import React, { Component } from 'react'
import { Button, Card, Checkbox, FormControl, IconButton, InputLabel, MenuItem, Select, Tooltip, Typography } from '@mui/material';
import { MdDragIndicator } from 'react-icons/md';
import { isMobile } from 'react-device-detect';
import SFLineChart2 from '../../SFCharts/Line/SFLineChart2';
import { TbTargetArrow } from 'react-icons/tb';
import ApiRequestService from '../../../../components/ApiRequestService';
import { AppContext } from '../../../../AppContext';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { NotificationManager } from 'react-notifications';
import { FaCirclePlus } from 'react-icons/fa6';
import { IoRemoveCircleOutline, IoTimeSharp } from 'react-icons/io5';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import SFNoData from '../../../SFComponents/SFNoData';

/* 
    {
        categoryName: "",
        data: [
            {
                attempt: 1,
                color: "",
                data: [],
            }
        ]
    }
*/

let colors = [
    "#74ADE4", "#3FB68E", "#ED8D61", "#F36A94", "#AA7ED7", "#3DB5C5",
    "#FFD166", "#EF476F", "#06D6A0", "#118AB2", "#FF7C43", "#9F86C0",
    "#F4A261", "#2A9D8F", "#E76F51", "#E0CA3C", "#D72638", "#3F88C5",
    "#A1C181", "#6A4C93"
];

let darkenedColors = [
    "#4984B5", "#2C896C", "#BE6F4D", "#C15278", "#895DB0", "#2E8E9E",
    "#CCAB28", "#BF3658", "#04A881", "#0D6E8E", "#CC6336", "#8069A0",
    "#C27F4D", "#217366", "#B55841", "#B5A12F", "#A11F2C", "#316BA0",
    "#7F9B65", "#513B76"
];

let transparentColors = [
    "rgba(116, 173, 228, 0.3)", // #74ADE4
    "rgba(63, 182, 142, 0.3)",  // #3FB68E
    "rgba(237, 141, 97, 0.3)",  // #ED8D61
    "rgba(243, 106, 148, 0.3)", // #F36A94
    "rgba(170, 126, 215, 0.3)", // #AA7ED7
    "rgba(61, 181, 197, 0.3)",  // #3DB5C5
    "rgba(255, 209, 102, 0.3)", // #FFD166
    "rgba(239, 71, 111, 0.3)",  // #EF476F
    "rgba(6, 214, 160, 0.3)",   // #06D6A0
    "rgba(17, 138, 178, 0.3)",  // #118AB2
    "rgba(255, 124, 67, 0.3)",  // #FF7C43
    "rgba(159, 134, 192, 0.3)", // #9F86C0
    "rgba(244, 162, 97, 0.3)",  // #F4A261
    "rgba(42, 157, 143, 0.3)",  // #2A9D8F
    "rgba(231, 111, 81, 0.3)",  // #E76F51
    "rgba(224, 202, 60, 0.3)",  // #E0CA3C
    "rgba(215, 38, 56, 0.3)",   // #D72638
    "rgba(63, 136, 197, 0.3)",  // #3F88C5
    "rgba(161, 193, 129, 0.3)", // #A1C181
    "rgba(106, 76, 147, 0.3)"   // #6A4C93
];

const MAX_TIME = 30;

class PerformanceWidget extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            topics: [],
            selectedTopic: null,
            loading: false,
            highlightedCategories: [],
            tab: "by-topics",
            checkedCategories: [],
            mostRecentAssignment: null,
            selectedKey: "most_recent_assignment",
        }
    }

    componentDidMount() {
        if (this.props.selectedCourse) {
            this.getByTopics();
            this.getMostRecentAssignment();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedCourse?.course_id !== this.props.selectedCourse?.course_id) {
            this.getByTopics();
        }
        if (prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.getMostRecentAssignment();
            this.getByTopics();
        }
    }

    getMostRecentAssignment = () => {
        this.setState({
            loading: true,
        })
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getMostRecentAssignmentData",
            data: {
                course_id: this.props.selectedCourse.course_id,
                userName: this.props.selectedStudentUserName,
            }
        });
        responsePromise.then(res => {
            console.debug("res>>??", res)
            if (res && res.data && res.data.data) {
                this.setState({
                    selectedTopic: res.data.data,
                    mostRecentAssignment: res.data.data,
                })
            }
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    getByTopics = () => {

        this.setState({
            loading: true,
        })

        let payload = {
            courseID: this.props.selectedCourse.course_id,
            userName: this.props.selectedStudentUserName,
        }

        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByTopics",
            data: payload
        });

        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    let topics = res.data.data;
                    if (topics && topics.length) {
                        // let firstTopic = topics[0];
                        this.setState({
                            topics: topics,
                            // selectedTopic: firstTopic,
                        })
                    }
                } else {
                    this.setState({
                        topics: [],
                        selectedTopic: null,
                    })
                }
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }

    getDataSets = (selectedTopic, type) => {
        let datasets = [];
        let categoryDataArr = [];
        if (this.state.selectedKey === "most_recent_assignment") {
            if (this.state.mostRecentAssignment && this.state.mostRecentAssignment.categoryDataArr) {
                categoryDataArr = [...this.state.mostRecentAssignment.categoryDataArr];
            }
        } else {
            if (selectedTopic && selectedTopic.categoryAnalytic) {
                categoryDataArr = [...selectedTopic.categoryAnalytic];
            }
        }
        if (categoryDataArr && categoryDataArr.length) {
            categoryDataArr.map((catAnalytic, index) => {
                let catKey = `${catAnalytic.subjectID}_${catAnalytic.topicID}_${catAnalytic.categoryID}`;
                let dataArr = [];
                let realDataArr = [];
                let practiceArr = catAnalytic?.categoryPracticeDataArr;
                if (this.state.selectedKey === "most_recent_assignment") {
                    practiceArr = catAnalytic?.categoryPracticeDataAcrossArr;
                }
                if (type === "accuracy") {
                    dataArr = practiceArr?.map(cp => cp.accuracyPercent);
                } else {
                    dataArr = practiceArr?.map(cp => (cp.time / 60).toFixed(1));
                    // dataArr = [15, 40, 30, 3000, 20]
                    realDataArr = [...dataArr];
                    dataArr = dataArr.map(d => d > MAX_TIME ? MAX_TIME : d)
                    
                }

                let highlightedCategoryIndex = this.state.highlightedCategories?.findIndex(hc => {
                    let key = `${hc.subjectID}_${hc.topicID}_${hc.categoryID}`;
                    return catKey === key;
                })

                if (highlightedCategoryIndex > -1) {
                    datasets.push({
                        label: type === "accuracy" ? "Accuracy" : "Time",
                        data: dataArr,
                        realDataArr,
                        borderColor: colors[index] ? colors[index] : colors[0],
                        borderWidth: 10,
                        pointBorderWidth: 0,
                        pointBackgroundColor: "#333",
                        pointBorderColor: '#333',
                        pointStyle: false,
                        order: 1,
                        datalabels: { display: false },
                    });

                } else {
                    datasets.push({
                        label: type === "accuracy" ? "Accuracy" : "Time",
                        data: dataArr,
                        realDataArr,
                        borderColor: transparentColors[index] ? transparentColors[index] : transparentColors[0],
                        borderWidth: 10,
                        pointRadius: 2,
                        pointBorderWidth: 0,
                        pointBackgroundColor: '#333',
                        pointBorderColor: '#333',
                        pointStyle: false,
                        order: 4, // Below selected line
                        datalabels: { display: false },
                    });
                }

            })
        }
        return datasets;
    }

    handleAddToPracticeSetCart = () => {
        const newCategories = this.state.checkedCategories.filter(checkedCat => {
            const checkedCatKey = `${checkedCat.subjectID}_${checkedCat.topicID}_${checkedCat.categoryID}`;
            return !this.context.selectedCategories.some(selectedCat => {
                const selectedCatKey = `${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}`;
                return checkedCatKey === selectedCatKey;
            });
        });

        if (newCategories.length > 0) {
            this.context.handleAddCategories(newCategories);
        }

        // Clear all checked categories after adding
        this.setState({
            checkedCategories: [],
        });
    };



    render() {

        const {
            selectedCategories, handleAddCategory, handleRemoveCategory, handleAddCategories, onAddActivityLog
        } = this.context;

        let categoryArr = [];
        if (this.state.selectedTopic) {
            if (this.state.selectedKey === "most_recent_assignment") {
                categoryArr = this.state.selectedTopic?.categoryDataArr;
            } else {
                categoryArr = this.state.selectedTopic?.categoryAnalytic;
            }
        }

        let accuracyDataArr = this.getDataSets(this.state.selectedTopic, "accuracy");
        let timeDataArr = this.getDataSets(this.state.selectedTopic, "time");

        let accuracyMaxCount = 0;
        accuracyDataArr.forEach(accuracyData => {
            let l = accuracyData?.data?.length ? accuracyData?.data?.length : 0;
            if (l > accuracyMaxCount) {
                accuracyMaxCount = l;
            }
        })

        let timeMaxCount = 0;
        timeDataArr.forEach(timeData => {
            let l = timeData?.data?.length ? timeData?.data?.length : 0;
            if (l > timeMaxCount) {
                timeMaxCount = l;
            }
        })

        return (
            <Card className='h-100 w-100 position-relative'
                style={{ backgroundColor: '#fff', position: 'relative' }} sx={{ boxShadow: 3, borderRadius: 2 }}
            >
                <div className='d-flex justify-content-between align-items-center px-3 pt-3'>
                    <Typography
                        fontSize={isMobile ? 16 : 18}
                        fontWeight={'500'} >
                        Performance Analytics
                    </Typography>
                    {/* <div className='performance-tab'>
                        <div className={`${this.state.tab === 'by-topics' ? 'active' : ''}`}
                            onClick={() => this.setState({ tab: 'by-topics' })}
                        >By Topic</div>
                        <div className={`${this.state.tab === 'by-assignments' ? 'active' : ''}`}
                            onClick={() => this.setState({ tab: 'by-assignments' })}
                        >By Assignments</div>
                    </div> */}
                    <div className='cursor-pointer drag-handle' style={{ cursor: 'move' }}>
                        <MdDragIndicator fontSize={24} />
                    </div>
                </div>

                {this.state.loading ?
                    <div className='h-100 mt-5 position-relative px-4'>
                        <div className='w-100 position-relative'>
                            <Skeleton className='my-2' count={5} />
                        </div>
                    </div>
                    :
                    (this.state.selectedTopic === null || this.state.selectedTopic === undefined ?
                        <div className='d-flex justify-content-center align-items-center h-50'>
                            <SFNoData
                                title={`You have not started any ${this.context.isSpecial ? "skills" : "assignments"} yet`}
                                description={`Start attending ${this.context.isSpecial ? "skills" : "assignments"} to see your progress`}
                            />
                        </div>
                        :
                        <div style={{ overflow: "auto", height: "calc(100% - 50px)", }}>
                            <div className='d-flex justify-content-center align-items-center mt-3'>
                                <div className='mr-2'>
                                    <Typography fontWeight={600}>Choose a Topic</Typography>
                                </div>
                                <div style={{
                                    width: "230px",
                                }}>
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="select-topic"
                                            id="select-topic"
                                            size='small'
                                            value={this.state.selectedKey}
                                            onChange={(e) => {
                                                let key = e.target.value;
                                                let activityLogPayload = {};
                                                if (key === "most_recent_assignment") {
                                                    this.setState({
                                                        selectedTopic: this.state.mostRecentAssignment
                                                    })
                                                    activityLogPayload = {
                                                        toNomenclatureID: 0, // clicked
                                                        quizID: this.state.mostRecentAssignment.quizID,
                                                        log: "Most Recent Assignment",
                                                        activityTypeID: 28, // Choose A Topic
                                                        courseID: this.props.selectedCourse.course_id,
                                                    }
                                                } else {
                                                    let topic = this.state.topics.find(topic => topic.key == key);
                                                    this.setState({
                                                        selectedTopic: topic
                                                    })
                                                    activityLogPayload = {
                                                        toNomenclatureID: 0, // clicked
                                                        subjectID: topic.subjectID,
                                                        topicID: topic.topicID,
                                                        log: "Topic choosen",
                                                        activityTypeID: 28, // Choose A Topic
                                                        courseID: this.props.selectedCourse.course_id,
                                                    }
                                                }
                                                this.setState({
                                                    selectedKey: key,
                                                    highlightedCategories: [],
                                                })

                                                console.debug("activityLogPayload>>??", activityLogPayload)
                                                if (this.props.selectedStudentUserName) {
                                                    return;
                                                }

                                                onAddActivityLog(activityLogPayload);
                                            }}
                                        >
                                            <MenuItem value={"most_recent_assignment"}>Most Recent Assignment</MenuItem>
                                            {this.state.topics.map(topic => {
                                                return (
                                                    <MenuItem value={topic.key}>{topic.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className='d-flex justify-content-center align-items-center mt-4' style={{
                                gap: '2rem',
                            }}>
                                <SFLineChart2
                                    chartType="accuracy"
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} />
                                                    Accuracy %
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={"Accuracy %"}
                                    labelsMaxCount={accuracyMaxCount}
                                    datasetsProp={accuracyDataArr}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                    width="300px"
                                />
                                <SFLineChart2
                                    chartType="time"
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <IoTimeSharp fontSize={22} />
                                                    Time Taken (min)
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={"Time Taken (min)"}
                                    labelsMaxCount={timeMaxCount}
                                    datasetsProp={timeDataArr}
                                    min={0}
                                    max={MAX_TIME}
                                    stepSize={20}
                                    width="300px"
                                />
                            </div>

                            <div className='d-flex justify-content-center w-100 mt-5'>
                                <div>
                                    <Typography className='my-1' fontWeight={600}>CATEGORIES</Typography>

                                    <div className="category-grid">
                                        {categoryArr && categoryArr.length > 0 ? (
                                            categoryArr.map((cat, index) => {
                                                const catKey = `${cat.subjectID}_${cat.topicID}_${cat.categoryID}`;
                                                const isSelected = selectedCategories?.some(cc => {
                                                    const key = `${cc.subjectID}_${cc.topicID}_${cc.categoryID}`;
                                                    return key === catKey;
                                                });

                                                const isHighlighted = this.state.highlightedCategories?.some(hc => {
                                                    const key = `${hc.subjectID}_${hc.topicID}_${hc.categoryID}`;
                                                    return key === catKey;
                                                });

                                                return (
                                                    <div
                                                        onClick={() => {
                                                            let activityLogPayload = {};
                                                            if (isHighlighted) {
                                                                let highlightedCategories = this.state.highlightedCategories;
                                                                let index = this.state.highlightedCategories.findIndex(hc => {
                                                                    const key = `${hc.subjectID}_${hc.topicID}_${hc.categoryID}`;
                                                                    return key === catKey;
                                                                })
                                                                if (index > -1) {
                                                                    highlightedCategories.splice(index, 1);
                                                                    this.setState({
                                                                        highlightedCategories,
                                                                    })
                                                                }
                                                            } else {
                                                                this.setState({
                                                                    highlightedCategories: [...this.state.highlightedCategories, cat]
                                                                })
                                                            }
                                                            activityLogPayload = {
                                                                toNomenclatureID: 0, // clicked
                                                                subjectID: cat.subjectID,
                                                                topicID: cat.topicID,
                                                                categoryID: cat.categoryID,
                                                                log: "",
                                                                activityTypeID: isHighlighted ? 30 : 29, // Category highlighted
                                                                courseID: this.props.selectedCourse.course_id,
                                                            }
                                                            if (this.state.selectedKey === "most_recent_assignment") {
                                                                activityLogPayload.quizID = this.state.mostRecentAssignment?.quizID;
                                                            }
                                                            if (this.props.selectedStudentUserName) {
                                                                return;
                                                            }
                                                            onAddActivityLog(activityLogPayload);
                                                        }}
                                                        key={index}
                                                        className="category-item d-flex justify-content-between align-items-center cursor-pointer"
                                                        style={{
                                                            backgroundColor: isHighlighted ? '#eff1f2' : 'transparent',
                                                            borderRadius: '6px',
                                                        }}
                                                    >
                                                        <div className='d-flex align-items-start' style={{ gap: "4px", width: "300px" }}>
                                                            <div
                                                                className='category-cell-chip'
                                                                style={{
                                                                    backgroundColor: colors[index],
                                                                    border: "4px solid",
                                                                    borderColor: isHighlighted ? darkenedColors[index] : 'transparent',
                                                                }}
                                                            />
                                                            <div className='cursor-pointer'>
                                                                {cat.name}
                                                            </div>
                                                        </div>

                                                        {/* <button className={`
                                                            cat-add-btn
                                                            ${isSelected ? 'cat-remove-btn' : ''}
                                                        `}
                                                            onClick={() => {
                                                                if (isSelected) {
                                                                    handleRemoveCategory(cat);
                                                                } else {
                                                                    handleAddCategory(cat);
                                                                }
                                                            }}
                                                        >
                                                            {isSelected ? "Remove"  : "Add"}
                                                        </button> */}
                                                        <Tooltip
                                                            title={
                                                                isSelected ? "Remove from practice set" : "Add to practice set"
                                                            }
                                                            placement='top'
                                                            arrow
                                                        >
                                                            <IconButton
                                                                className='p-0 m-0'
                                                                color='primary'
                                                                disabled={this.props.selectedStudentUserName}
                                                                // size='small'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (isSelected) {
                                                                        handleRemoveCategory(cat);
                                                                    } else {
                                                                        handleAddCategory(cat);
                                                                    }
                                                                    let activityLogPayload = {
                                                                        toNomenclatureID: 0, // clicked
                                                                        subjectID: cat.subjectID,
                                                                        topicID: cat.topicID,
                                                                        categoryID: cat.categoryID,
                                                                        log: isSelected ? "Removed from Practice Set Cart" : "Add to Practice Set Cart",
                                                                        activityTypeID: isSelected ? 32 : 31, // Category Added
                                                                        courseID: this.props.selectedCourse.course_id,
                                                                    }

                                                                    if (this.state.selectedKey === "most_recent_assignment") {
                                                                        activityLogPayload.quizID = this.state.mostRecentAssignment?.quizID;
                                                                    }

                                                                    console.debug("activityLogPayload>>??", activityLogPayload);
                                                                    onAddActivityLog(activityLogPayload);
                                                                }}>
                                                                <span>
                                                                    {isSelected ?
                                                                        <IoMdCloseCircleOutline />
                                                                        :
                                                                        <FaCirclePlus />
                                                                    }
                                                                </span>
                                                            </IconButton>
                                                        </Tooltip>
                                                        {/* <Checkbox
                                                            checked={isSelected}
                                                            size='small'
                                                            style={{ padding: 0 }}
                                                            onChange={(event) => {
                                                                const value = event.target.checked;
                                                                let checkedCategories = [...this.state.checkedCategories];

                                                                if (value) {
                                                                    checkedCategories.push(cat);
                                                                } else {
                                                                    const catIndex = checkedCategories.findIndex(cc => {
                                                                        const key = `${cc.subjectID}_${cc.topicID}_${cc.categoryID}`;
                                                                        return key === catKey;
                                                                    });
                                                                    if (catIndex > -1) {
                                                                        checkedCategories.splice(catIndex, 1);
                                                                    }
                                                                }

                                                                this.setState({ checkedCategories });
                                                            }}
                                                        /> */}
                                                    </div>
                                                );
                                            })
                                        ) : null}

                                        {/* filler to maintain 2 columns if odd number */}
                                        {categoryArr && categoryArr.length % 2 !== 0 && (
                                            <div className="category-item empty"></div>
                                        )}
                                    </div>
                                </div>
                            </div>


                            <div style={{ display: "flex", justifyContent: "flex-end" }} className='mr-2'>
                                {this.state.checkedCategories && this.state.checkedCategories.length > 0 ?
                                    <Button variant='contained' onClick={this.handleAddToPracticeSetCart}>
                                        Add to Practice Set
                                    </Button>
                                    : null}
                            </div>
                        </div>
                    )
                }

                {/* <div>
                    <Button></Button>
                </div> */}

            </Card>
        )
    }
}

export default PerformanceWidget;
